import image1 from 'assets/backgrounds/image1.jpg'
import image2 from 'assets/backgrounds/image2.jpg'
import image3 from 'assets/backgrounds/image3.jpg'
import image4 from 'assets/backgrounds/image4.jpg'
import React from 'react'
import { useVirtualBackground } from './contexts/VirtualBackgroundContext'
import { CloseButton, OptionButton, SectionTitle, SidePanel } from './styles'
import {
  VIDEO_CALL_MEET_TEST_IDS,
  videoCallMeetBackgroundImageTestId,
} from './testIds'

const PRESET_IMAGES = [image1, image2, image3, image4]

interface Props {
  isOpen: boolean
  onClose: () => void
}

export default function VirtualBackgroundPanel({ isOpen, onClose }: Props) {
  const { mode, imageUrl, setNone, setBlur, setImage } = useVirtualBackground()

  if (!isOpen) return null

  return (
    <SidePanel data-testid={VIDEO_CALL_MEET_TEST_IDS.backgroundPanel}>
      <SectionTitle data-testid={VIDEO_CALL_MEET_TEST_IDS.backgroundSectionTitle}>
        Plano de fundo
      </SectionTitle>
      <OptionButton
        data-testid={VIDEO_CALL_MEET_TEST_IDS.backgroundNone}
        selected={mode === 'none'}
        onClick={() => {
          void setNone()
        }}
      >
        Sem plano de fundo
      </OptionButton>
      <OptionButton
        data-testid={VIDEO_CALL_MEET_TEST_IDS.backgroundBlur}
        selected={mode === 'blur'}
        onClick={() => {
          void setBlur()
        }}
      >
        Desfoque
      </OptionButton>
      <div
        data-testid={VIDEO_CALL_MEET_TEST_IDS.backgroundImageGrid}
        style={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          gap: 8,
          marginBottom: 8,
        }}
      >
        {PRESET_IMAGES.map((url, index) => {
          const selected = mode === 'image' && imageUrl === url

          return (
            <button
              key={url}
              type="button"
              data-testid={videoCallMeetBackgroundImageTestId(index)}
              onClick={() => {
                void setImage(url)
              }}
              title={`Imagem ${index + 1}`}
              style={{
                border: selected ? '2px solid #53b486' : '1px solid #2c3446',
                borderRadius: 8,
                padding: 0,
                background: '#1f2533',
                cursor: 'pointer',
                overflow: 'hidden',
              }}
            >
              <img
                src={url}
                alt={`Preview imagem ${index + 1}`}
                style={{
                  width: '100%',
                  height: 74,
                  objectFit: 'cover',
                  display: 'block',
                }}
              />
              <span
                style={{
                  display: 'block',
                  color: '#fff',
                  fontSize: 12,
                  padding: '6px 4px',
                }}
              >
                Imagem {index + 1}
              </span>
            </button>
          )
        })}
      </div>
      <CloseButton
        data-testid={VIDEO_CALL_MEET_TEST_IDS.backgroundClose}
        onClick={onClose}
      >
        Fechar
      </CloseButton>
    </SidePanel>
  )
}
